import { render, staticRenderFns } from "./CTAbutton.vue?vue&type=template&id=40cc0e7c&scoped=true&"
import script from "./CTAbutton.vue?vue&type=script&lang=js&"
export * from "./CTAbutton.vue?vue&type=script&lang=js&"
import style0 from "./CTAbutton.vue?vue&type=style&index=0&id=40cc0e7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cc0e7c",
  null
  
)

export default component.exports